import http from '../http';
// import Qs from "qs";

// 设置上课时间
const setCourse = params =>
  http
    .post('/courseClass/classSet', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then(res => res.data);
// (后台、 小程序)获取服务下面的校区
const getOrgBranchList = params =>
// .get("/sysOrganizationBranchs/orgBranch", { params })

  http
    .get('/sysOrganizationBranchs/orgBranch', { params })
    .then(res => res.data);

// 课班 ----------------------------------------- start
// 服务添加课班模板
const addCourse = params =>
  http
    .post('/daycareTemplate/addCourse', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then(res => res.data);
// 服务编辑课班模板
const editCourse = params =>
  http
    .post('/daycareTemplate/org/editCourse', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then(res => res.data);
// 学校课班模板列表
const getCourseClassList = params =>
  http
    .get('/daycareTemplate/school/courseClass/page', { params })
    .then(res => res.data);
// 学校引入课班
const importClass = params =>
  http
    .post('/daycareTemplate/school/introduce/courseClass', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then(res => res.data);

// 课班 ----------------------------------------- end

// 托管 ----------------------------------------- start
// 服务添加托管模板
const addDaycare = params =>
  http
    .post('/daycareTemplate/addDaycare', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then(res => res.data);

// 服务编辑托管模板
const editDaycare = params =>
  http
    .post('/daycareTemplate/org/editDaycare', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then(res => res.data);

// /daycareTemplate/org/editDaycare

// 服务托管列表(已引入)
const getDaycareList = params =>
  http.get('/daycare/org/page', { params }).then(res => res.data);
// 托管 ----------------------------------------- end

// 服务查询模板列表（库）
const getDaycareTemplateList = params =>
  http.get('/daycareTemplate/org/page', { params }).then(res => res.data);

// 模板详情
const detailDaycare = params =>
  http.get('/daycareTemplate/detail', { params }).then(res => res.data);

// 服务删除模板
// const deleteDaycare = params =>
//   http
//     .post("/daycareTemplate/org/delete", params, {
//       headers: { "Content-Type": "application/json" }
//     })
//     .then(res => res.data);

const deleteDaycare = params =>
  http.delete('/daycareTemplate/org/delete', { params }).then(res => res.data);

// 学校端查询托管列表
const getSchoolDaycareList = params =>
  http.get('/daycare/school/page', { params }).then(res => res.data);

// 学校添加托管
const addSchoolDayCare = params =>
  http
    .post('/daycare/school/add', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then(res => res.data);

// 查询未发布的（课班、托管列表）
const getListUnPubBySchool = params =>
  http.get('/courseClass/listUnPubBySchool', { params }).then(res => res.data);

// 学校编辑托管
const updateSchoolDayCare = params =>
  http
    .post('/daycare/school/update', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then(res => res.data);

// 学校发布托管
const schoolPublishClasses = params =>
  http
    .post('/courseClass/publishClasses', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then(res => res.data);

// 学校查询服务托管模板列表
const getOrgTemplete = params =>
  http
    .get('/daycareTemplate/school/daycareClass/page', { params })
    .then(res => res.data);

// 查询学校发布列表
const getPublishList = params =>
  http.get('/schoolPublishs/listByType', { params }).then(res => res.data);

// 查询学校发布列表
const getPublishDatails = params =>
  http.get('/schoolPublishs/detail', { params }).then(res => res.data);

// 修改发布课班
const editSchoolPublishClasses = params =>
  http
    .post('/courseClass/updatePublish', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then(res => res.data);

// 学校引入托管班
const daycareImport = params =>
  http
    .post('/daycareTemplate/school/introduce/daycareClass', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then(res => res.data);

export default {
  addCourse,
  addDaycare,
  getOrgBranchList,
  getDaycareList,
  getDaycareTemplateList,
  deleteDaycare,
  detailDaycare,
  editDaycare,
  editCourse,
  getSchoolDaycareList,
  addSchoolDayCare,
  getListUnPubBySchool,
  updateSchoolDayCare,
  schoolPublishClasses,
  getOrgTemplete,
  getPublishList,
  getPublishDatails,
  editSchoolPublishClasses,
  daycareImport,
  getCourseClassList,
  importClass,
  setCourse
};
